module.exports = __webpack_public_path__ + "img/usb-manage.517ed22c.png";